import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';

@Component({
  selector: 'app-class-layout',
  templateUrl: './class-layout.component.html',
  styleUrls: ['./class-layout.component.css']
})
export class ClassLayoutComponent implements OnInit {

  public isShowPreloader: boolean = true;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {
    _router.events.subscribe((routerEvent: any) => {
      this.checkRouteChange(routerEvent);
    });
  }

  ngOnInit(): void {
    this._activatedRoute.data.subscribe((_routerData: any) => {
      this.checkLiveClassCSS(_routerData);
    })
  }

  checkLiveClassCSS = (_routerData: any = null) => {
    let head = document.getElementsByTagName('head');
    let cd = head[0].querySelectorAll("link.live-styles");
    if (cd && cd?.length > 0) {
      for (let i = 0; i < cd.length; i++) {
        head[0].removeChild(cd[i]);
      }
    }

    if (_routerData?.isLiveClass != undefined && _routerData?.isLiveClass) {
      let linkNode1 = document.createElement('link');
      linkNode1.setAttribute('rel', 'stylesheet');
      linkNode1.setAttribute('href', '/assets/css/live-portal-styles.css');
      linkNode1.className = 'live-styles';
      let linkNode2 = document.createElement('link');
      linkNode2.setAttribute('rel', 'stylesheet');
      linkNode2.setAttribute('href', '/assets/css/live-class-style.css');
      linkNode2.className = 'live-styles';
      let linkNode3 = document.createElement('link');
      linkNode3.setAttribute('rel', 'stylesheet');
      linkNode3.setAttribute('href', '/assets/css/responsive.css');
      linkNode3.className = 'live-styles';
      head[0].appendChild(linkNode1);
      head[0].appendChild(linkNode2);
      head[0].appendChild(linkNode3);
    }
  }

  checkRouteChange(routerEvent: RouterEvent) {
    if (routerEvent instanceof NavigationStart) {
      document.body.classList.add('no-scroll')
      this.isShowPreloader = true;
    }
    if (routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError
    ) {
      setTimeout(() => {
        document.body.classList.remove('no-scroll');
        this.isShowPreloader = false;
      }, 500);
    }
  }
}
